(function () {
  'use strict';

  // Custom namespace for Curacao (avoid mixing with vendor theme namespaces).
  window.Curacao = window.Curacao || {};

  /**
   * Zip code inputs: numeric only, max 5 chars.
   * @param {Document|Element} container
   */
  function init(container) {
    var root = container || document;
    if (!root || !root.querySelectorAll) return;

    var inputs = root.querySelectorAll('input.product-store-default-zip-code');
    if (!inputs || !inputs.length) return;

    inputs.forEach(function (zipCodeInput) {
      if (!zipCodeInput || zipCodeInput.dataset.zipCodeNumericInit === '1') return;
      zipCodeInput.dataset.zipCodeNumericInit = '1';

      zipCodeInput.addEventListener('keydown', function (e) {
        var key = e.key;
        var ctrlKey = e.ctrlKey;
        var metaKey = e.metaKey;

        var allowedKeys = [
          'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
          'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
          'Home', 'End'
        ];

        if (ctrlKey || metaKey) {
          if (['a', 'c', 'v', 'x'].includes(key.toLowerCase())) {
            return true;
          }
        }

        if (allowedKeys.includes(key)) {
          return true;
        }

        if (!/^\d$/.test(key)) {
          e.preventDefault();
          return false;
        }

        if (this.value.length >= 5 && !['Backspace', 'Delete'].includes(key)) {
          e.preventDefault();
          return false;
        }
      });

      zipCodeInput.addEventListener('input', function (e) {
        var input = e.target;
        var originalValue = input.value;
        var sanitizedValue = originalValue.replace(/\D/g, '').slice(0, 5);

        if (originalValue !== sanitizedValue) {
          var cursorPosition = input.selectionStart;
          input.value = sanitizedValue;
          var newPosition = Math.min(
            cursorPosition - (originalValue.length - sanitizedValue.length),
            sanitizedValue.length
          );
          input.setSelectionRange(newPosition, newPosition);
        }
      });

      zipCodeInput.addEventListener('paste', function (e) {
        e.preventDefault();

        var clipboardData = e.clipboardData || window.clipboardData || {};
        var pastedText = clipboardData.getData('text') || '';

        var numericOnly = pastedText.replace(/\D/g, '').slice(0, 5);

        var start = this.selectionStart;
        var end = this.selectionEnd;
        var currentValue = this.value;

        var newValue = currentValue.slice(0, start) + numericOnly + currentValue.slice(end);
        var finalValue = newValue.replace(/\D/g, '').slice(0, 5);

        this.value = finalValue;

        var newCursorPosition = Math.min(start + numericOnly.length, finalValue.length);
        this.setSelectionRange(newCursorPosition, newCursorPosition);

        this.dispatchEvent(new Event('input', { bubbles: true }));
      });
    });
  }

  window.Curacao.ZipCodeInput = { init: init };
})();


